//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            building: '',
            buildingStats: [],
            residents: [],
            inspections: [],
            buildings: [],
            statsLoading: true
        };
    },

    computed: {
        formattedVacancyRate: function formattedVacancyRate() {
            if (this.buildingStats.vacancyRate != null) {
                return this.buildingStats.vacancyRate * 100;
            }

            return '';
        }
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('view-building', function (item) {
            $el.building = item;
            $el.statsLoading = true;
            $el.$children[0].$data.showModal = true;
            Event.$emit('show-property-tab-residents');

            _this.buildingStats = [];

            if ($el.building.id) {
                axios.get('/prototype/buildings/' + $el.building.id + "/stats").then(function (response) {
                    if (response.data) {
                        $el.buildingStats = response.data;
                        $el.statsLoading = false;
                    }
                });
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/building/BuildingDetails.vue
// module id = sZgm
// module chunks = 0 1